// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__5WaVO","disabled":"styles_disabled__coxDL"};